import React from 'react';
import { Card, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import classNames from 'classnames/bind';
const cx = classNames.bind();

function FormGroup({ className, children }) {
    return <Card className={cx(`border border-gray ${className}`)}>{children}</Card>;
}
FormGroup.defaultProps = {
    className: '',
};
FormGroup.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

const Header = ({ className, children, increment }) => {
    return (
        <Card.Header className={cx(className, 'd-flex')}>
            <Card.Title className={'mr-auto d-flex'}>{children}</Card.Title>
            <Button
                type="button"
                variant="success"
                onClick={increment}
            >
                <i className="icon-plus font-weight-bold"></i>
            </Button>
        </Card.Header>
    );
};
Header.defaultProps = {
    className: '',
};
Header.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    increment: PropTypes.func.isRequired,
};

const Body = ({ children }) => {
    return <Card.Body>{children}</Card.Body>;
};
Body.propTypes = {
    children: PropTypes.node.isRequired,
};

const Footer = ({ decrement }) => (
    <Card.Footer className={cx('d-flex flex-row-reverse')}>
        <Button
            type="button"
            variant="danger"
            onClick={decrement}
        >
            <i className="icon-minus font-weight-bold"></i>
        </Button>
    </Card.Footer>
);
Footer.propTypes = {
    decrement: PropTypes.func.isRequired,
};

FormGroup.Header = Header;
FormGroup.Body = Body;
FormGroup.Footer = Footer;

export default FormGroup;
